<template>
  <v-main> 
    <!-- 라우터에 의해 각페이지를 보여줌 -->      
    <div id="core-view">
      <v-fade-transition mode="out-in">
        <router-view> 
        </router-view>
      </v-fade-transition>
      <div style="width:100%; position:fixed; bottom : 0px;">
        <!-- <CoreFooter v-if="isLogin"/> -->
    </div>
      
    </div>
  </v-main>
</template>

<script>
// import CoreFooter from "@/components/core/Footer.vue";
// import {mapState} from "vuex";

export default {
  computed: {
    // ...mapState(["isLogin"]),        
  },
  components: {         
    // CoreFooter,        
  },
}
</script>

<style>
#core-view {
  padding-top: 0px;
  padding-bottom: 0px; 
}
</style>
